import { render } from "./Pages.vue?vue&type=template&id=a8bf00fe"
import script from "./Pages.vue?vue&type=script&lang=js"
export * from "./Pages.vue?vue&type=script&lang=js"
script.render = render

export default script